// src/support/useSupportTickets.js
import { useState, useEffect, useCallback } from 'react';
import { fetchUserTickets, fetchTicketDetail, createTicket, addComment } from './supportApi';

export default function useSupportTickets(account) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadTickets = useCallback(async (filters = {}) => {
    if (!account) return;
    setLoading(true);
    setError(null);
    try {
      const result = await fetchUserTickets(account, filters);
      setTickets(result.tickets || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [account]);

  useEffect(() => {
    loadTickets();
  }, [loadTickets]);

  const create = useCallback(async (ticketData) => {
    const result = await createTicket({ ...ticketData, userAddress: account });
    await loadTickets();
    return result;
  }, [account, loadTickets]);

  const getDetail = useCallback(async (ticketId) => {
    return fetchTicketDetail(ticketId, account);
  }, [account]);

  const reply = useCallback(async (ticketId, comment) => {
    const result = await addComment(ticketId, account, comment);
    return result;
  }, [account]);

  return {
    tickets,
    loading,
    error,
    createTicket: create,
    getDetail,
    reply,
    refresh: loadTickets,
  };
}
